/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { type PipeTransform, Pipe } from '@angular/core';
import { I18nService, UNPLACEHOLDER } from '@dm/core';

import { type KeyValue } from '../types/key-value';

/**
 * 获取key-value的i18n值
 */
@Pipe({ name: 'keyValue' })
export class KeyValuePipe implements PipeTransform {
    constructor(private i18nService: I18nService) {}

    transform(value: string | number, kv: KeyValue): string {
        let i18n;
        for (const k of Object.keys(kv)) {
            if (typeof kv[k].value === 'string' && kv[k].value === String(value) ||
                typeof kv[k].value === 'number' && kv[k].value === Number(value)) {
                i18n = kv[k].i18n;
                break;
            }
        }
        return i18n ? this.i18nService.get(i18n) : UNPLACEHOLDER;
    }
}
